import { FormattedMessage } from 'react-intl'

import ButtonComponent from '../../../../components/stories/atoms/button'
import {
  buttonSizeOptions,
  buttonVariantOptions
} from '../../../../components/stories/atoms/button/constants'

import { IntercomLink } from '../../../HelpMenu/intercom'
import { FooterLink, FooterLinksContainer } from '../../styled-components.js'

const LoginFooterLinks = ({ isInPopup, openResetPassword }) => {
  return (
    <FooterLinksContainer>
      {!isInPopup && (
        <>
          <FooterLink>
            <FormattedMessage id="login_dont_have_account" />
            <ButtonComponent
              variant={buttonVariantOptions.LINK}
              size={buttonSizeOptions.MEDIUM}
              emphasis={true}
              to={'/register'}
            >
              <FormattedMessage id="login_register_here" />
            </ButtonComponent>
          </FooterLink>
        </>
      )}
      <FooterLink>
        <FormattedMessage id="login_forget_password" />
        <ButtonComponent
          variant={buttonVariantOptions.LINK}
          size={buttonSizeOptions.MEDIUM}
          emphasis={true}
          to="#"
          onClick={openResetPassword}
        >
          <FormattedMessage id="login_reset_it" />
        </ButtonComponent>
      </FooterLink>

      <FooterLink>
        <FormattedMessage id="login_need_help" />
        <IntercomLink />
      </FooterLink>
    </FooterLinksContainer>
  )
}

export default LoginFooterLinks
